import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import GrowthHero from "../sections/GrowthHero";
import GrowthServices from "../sections/GrowthServices";
import "./GrowthPage.css";

export default function GrowthPage() {
  return (
    <>
      <Navbar />
      <main className="growth-main">
        <GrowthHero />
        <GrowthServices />
      </main>
      <Footer />
    </>
  );
}
